import { encodeRowColNumber } from '@libs/utils/tools'
import { type KK } from './define'

const generateSideLight = (row: number, col: number) => {
  const lk: Map<KK, number> = new Map()
  for (let i = 0; i < row; i++) {
    for (let j = 0; j < col; j++) {
      lk.set(encodeRowColNumber(i, j) as KK, 0)
    }
  }
  return lk
}

export const ra68SideLight: Map<KK, number> = generateSideLight(1, 25)
